import { Component, OnInit, HostListener, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, NavigationEnd, ActivatedRoute, RouterLink, RouterLinkActive } from '@angular/router';
import { Store } from '@ngxs/store';
import { GenericState } from '../../store/generic.state';
import { LaunchDarklyState } from '../../store/launch-darkly/launch-darkly.state';
import { GenericActions } from '../../store/generic.actions';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { MsalLoginService } from '../../services/msal.service';
import { CandidatePersonalDetailsAction } from 'src/app/store/candidate-profile/candidate-personal-details/candidate-personal-details.action';
import { CandidatePersonalDetailsState } from 'src/app/store/candidate-profile/candidate-personal-details/candidate-personal-details.state';
import {
	catchError,
	filter,
	finalize,
	takeUntil,
	take,
	firstValueFrom,
	lastValueFrom,
	throwError, 
	Subject
} from 'rxjs';
import { IdTokenClaims } from '@azure/msal-common';

import { environment } from 'src/environments/environment';
import {
	AccountInfo,
	AuthenticationResult,
	EventMessage,
	EventType,
	InteractionStatus,
	PopupRequest,
	RedirectRequest,
	SsoSilentRequest
} from '@azure/msal-browser';
import {
	MsalService,
	MsalBroadcastService,
	MSAL_GUARD_CONFIG,
	MsalGuardConfiguration
} from '@azure/msal-angular';
import { b2cPolicies } from '../../../identity/auth-config';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { GenericService } from 'src/app/services/generic.service';
import { ApplicationsActions } from 'src/app/store/applications/applications.action';
import { SavedJobsActions } from 'src/app/store/saved-jobs/saved-jobs.action';
import { IPersonalDetails } from 'src/app/store/candidate-profile/candidate-personal-details/candidate-personal-details.interface';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AuthActions } from 'src/app/store/auth/auth.action';
import { SITE_DATA } from '../../../app/productization/default.constant';
import { IpDetectorState } from 'src/app/store/ip-detector/ip-detector.state';
import * as _ from 'underscore';
import { SignupQuestionsSignal } from 'src/app/signal/signup-questions.signal';
import { FeatureFlaghService } from 'src/app/services/feature-flag.service';
import { distinctUntilChanged } from 'rxjs/operators';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { RegistrationComponent } from '../../shared/registration/registration.component';
import { RegistrationMoreComponent } from '../../shared/registration-more/registration-more.component';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NgClass } from '@angular/common';
import { NzInputModule } from 'ng-zorro-antd/input';
import { JobAlertComponent } from '../../shared/modal/job-alert/job-alert.component';
import { QrReferralComponent } from '../../shared/modal/qr-referral/qr-referral.component';
type IdTokenClaimsWithPolicyId = IdTokenClaims & {
	acr?: string;
	tfp?: string;
};
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [RouterLink, NzDropDownModule, NzIconModule, NzMenuModule, RouterLinkActive, NzSpaceModule, NzButtonModule, RegistrationComponent, RegistrationMoreComponent, NzDrawerModule, NzModalModule, FormsModule, ReactiveFormsModule, NgClass, NzInputModule, JobAlertComponent, QrReferralComponent]
})
export class HeaderComponent implements OnInit {
	private msalGuardConfig = inject<MsalGuardConfiguration>(MSAL_GUARD_CONFIG);
	private readonly authService = inject(MsalService);
	private readonly msalBroadcastService = inject(MsalBroadcastService);
	private readonly router = inject(Router);
	private readonly ngxLoader = inject(NgxUiLoaderService);
	private readonly genericService = inject(GenericService);
	private readonly msalLoginService = inject(MsalLoginService);
	private readonly notification = inject(NzNotificationService);
	private readonly nzMessage = inject(NzMessageService);
	private readonly fb = inject(FormBuilder);
	private readonly route = inject(ActivatedRoute);

	@HostListener('window:popstate')
	onPopState() {
		this.closeDrawer();
	}
	private readonly store = inject(Store);
	private readonly destroyRef = inject(DestroyRef);
	private readonly featureFlagService = inject(FeatureFlaghService);
	private readonly signupQuestionsSignal = inject(SignupQuestionsSignal);
	private readonly genericResult$ = this.store.select(GenericState.getGeneric);
	private readonly launchDarklyResult$ = this.store.select(LaunchDarklyState.getFlags);
	private readonly personalDetailsResult$ = this.store.select(CandidatePersonalDetailsState.getPersonalDetailsTab);
	private launchDarklyData: any;
	public genericData: any;
	public personalInfo: IPersonalDetails;

	public isShowLogin = false;

	public isRegistrationNav = false;
	public mobileDrawer = false;

	isIframe = false;
	loginDisplay = false;
	private readonly _destroying$ = new Subject<void>();

	public profilePix: string | null = '';

	public isCloudstaffer: boolean = false;

	public showChangePassword = false;
	public showCurrentPassword = false;
	public showNewPassword = false;
	public showConfirmPassword = false;

	public changePasswordForm: FormGroup;
	private strongPasswordRegx: RegExp =
		/^(?=[^A-Z]*[A-Z])(?=[^a-z]*[a-z])(?=.*[!@#$%^&*])(?=\D*\d).{8,}$/;
	public isPasswordSame = true;

	public isJobAlertModal = false;
	public isJobAlert = false;
	public isRegisteredCheckerVisible = false;
	public showQRModal = false;
	public hasReferralId = false;

	public siteData = SITE_DATA;
	private readonly getIpAddress = this.store.select(IpDetectorState.getIp);
	private readonly genericLookup = this.store.select(GenericState.getGeneric);
	public setCountryOrigin: string | null = null;

	constructor() {
		const router = this.router;

		router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				if (this.router.url === '/registration') {
					this.isRegistrationNav = true;
				} else {
					this.isRegistrationNav = false;
				}
			}

			this.launchDarklyResult$?.pipe(
				filter((e: any) => !_.isEmpty(e)),
				distinctUntilChanged((prev, curr) => _.isEqual(prev?.onboarding, curr?.onboarding))
			).subscribe((data) => {
				this.launchDarklyData = data;
			});
		});
	}

	async ngOnInit(): Promise<void> {
		const countryOrigin: any = await firstValueFrom(
			this.getIpAddress.pipe(
				filter((e: any) => !_.isEmpty(e)),
				take(1)
			)
		);

		const countryList: any = await lastValueFrom(
			this.genericLookup?.pipe(
				filter((e: any) => e.lookUpCountries.length > 0),
				take(1)
			)
		);

		if (this.siteData.defaultCountry === 'none') {
			if (countryList.lookUpCountries?.includes(countryOrigin.country_name)) {
				this.setCountryOrigin = countryOrigin.country_name;
			}
		} else {
			this.setCountryOrigin = this.siteData.defaultCountry;
		}

		this.route.queryParamMap.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
			this.hasReferralId = params.get('ref') ? true : false;
			if (this.hasReferralId) {
				this.store.dispatch(new GenericActions.ToggleRegistration());
			}
		});

		this.msalInitialize();
		this.genericResult$?.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
			if (this.hasReferralId && !data?.modalRegistration) {
				this.removeRefQueryString();
			}

			this.genericData = data;
			if (this.genericData.userRole && this.genericData.promptProperties) {
				this.isJobAlert = true;
				this.modalChecking();
				this.checkCloudstaffEmail();
			}
		});

		this.personalDetailsResult$?.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
			this.personalInfo = data.personalInfo;
		});
		this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params: any) => {
			if (params.csuid) {
				this.genericService
					.put('Applicant/AddReferCampaignClicks/1', null)
					.subscribe(() => {
						if (!this.loginDisplay) {
							this.showQRModal = true;
						}
					});
			}
		});
	}

	private checkCloudstaffEmail(): void {
		if (this.genericData.userRole.email.includes('@cloudstaff.com')) {
			this.isCloudstaffer = true;
		} else {
			this.isCloudstaffer = false;
		}
	}

	private msalInitialize(): void {
		this.isIframe = window !== window.parent && !window.opener;
		this.authService.instance.enableAccountStorageEvents(); // Optional - This will enable ACCOUNT_ADDED and ACCOUNT_REMOVED events emitted when a user logs in or out of another tab or window

		/**
		 * You can subscribe to MSAL events as shown below. For more info,
		 * visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-angular/docs/v2-docs/events.md
		 */
		this.msalBroadcastService.msalSubject$
			.pipe(
				filter(
					(msg: EventMessage) =>
						msg.eventType === EventType.ACCOUNT_ADDED ||
						msg.eventType === EventType.ACCOUNT_REMOVED
				)
			)
			.subscribe((result: EventMessage) => {
				if (this.authService.instance.getAllAccounts().length === 0) {
					window.location.pathname = '/';
				} else {
					this.setLoginDisplay();
				}
			});

		this.msalBroadcastService.inProgress$
			.pipe(
				filter(
					(status: InteractionStatus) => status === InteractionStatus.None
				),
				takeUntil(this._destroying$)
			)
			.subscribe(() => {
				this.setLoginDisplay();
				this.checkAndSetActiveAccount();
			});

		this.msalBroadcastService.msalSubject$
			.pipe(
				filter(
					(msg: EventMessage) =>
						msg.eventType === EventType.LOGIN_SUCCESS ||
						msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
						msg.eventType === EventType.SSO_SILENT_SUCCESS
				),
				takeUntil(this._destroying$)
			)
			.subscribe((result: EventMessage) => {
				let payload = result.payload as AuthenticationResult;
				let idtoken = payload.idTokenClaims as IdTokenClaimsWithPolicyId;

				if (
					idtoken.acr === b2cPolicies.names.signUpSignIn ||
					idtoken.tfp === b2cPolicies.names.signUpSignIn
				) {
					this.authService.instance.setActiveAccount(payload.account);
				}

				/**
				 * For the purpose of setting an active account for UI update, we want to consider only the auth response resulting
				 * from SUSI flow. "acr" claim in the id token tells us the policy (NOTE: newer policies may use the "tfp" claim instead).
				 * To learn more about B2C tokens, visit https://docs.microsoft.com/en-us/azure/active-directory-b2c/tokens-overview
				 */
				if (
					idtoken.acr === b2cPolicies.names.editProfile ||
					idtoken.tfp === b2cPolicies.names.editProfile
				) {
					// retrieve the account from initial sing-in to the app
					const originalSignInAccount = this.authService.instance
						.getAllAccounts()
						.find(
							(account: AccountInfo) =>
								account.idTokenClaims?.oid === idtoken.oid &&
								account.idTokenClaims?.sub === idtoken.sub &&
								((account.idTokenClaims as IdTokenClaimsWithPolicyId).acr ===
									b2cPolicies.names.signUpSignIn ||
									(account.idTokenClaims as IdTokenClaimsWithPolicyId).tfp ===
										b2cPolicies.names.signUpSignIn)
						);

					let signUpSignInFlowRequest: SsoSilentRequest = {
						authority: b2cPolicies.authorities.signUpSignIn.authority,
						account: originalSignInAccount
					};
					// silently login again with the signUpSignIn policy
					this.authService.ssoSilent(signUpSignInFlowRequest);
				}

				/**
				 * Below we are checking if the user is returning from the reset password flow.
				 * If so, we will ask the user to reauthenticate with their new password.
				 * If you do not want this behavior and prefer your users to stay signed in instead,
				 * you can replace the code below with the same pattern used for handling the return from
				 * profile edit flow (see above ln. 74-92).
				 */
				if (
					idtoken.acr === b2cPolicies.names.resetPassword.toLocaleLowerCase() ||
					idtoken.tfp === b2cPolicies.names.resetPassword.toLocaleLowerCase()
				) {
					this.nzMessage.success('Password changed successfully');
					this.logout();
				}
				return result;
			});

		this.msalBroadcastService.msalSubject$
			.pipe(
				filter(
					(msg: EventMessage) =>
						msg.eventType === EventType.LOGIN_FAILURE ||
						msg.eventType === EventType.ACQUIRE_TOKEN_FAILURE
				),
				takeUntil(this._destroying$)
			)
			.subscribe((result: EventMessage) => {
				if (result.error && result.error.message.indexOf('AADB2C90037') > -1) {
					this.isRegisteredCheckerVisible = true;
				}
				// Checking for the forgot password error. Learn more about B2C error codes at
				// https://learn.microsoft.com/azure/active-directory-b2c/error-codes

				if (result.error && result.error.message.indexOf('AADB2C90118') > -1) {
					let resetPasswordFlowRequest: RedirectRequest | PopupRequest = {
						authority: b2cPolicies.authorities.resetPassword.authority,
						scopes: []
					};

					this.login(resetPasswordFlowRequest);
				}
			});
	}

	setLoginDisplay() {
		this.loginDisplay = this.msalLoginService.checkUserLoggedIn();
		if (this.loginDisplay) {
			this.ngxLoader.start();
			this.genericService
				.get('ApplicantProtected/getMyUserRole')
				.pipe(
					finalize(() => this.ngxLoader.stop()),
					catchError((err) => {
						this.logout();
						return throwError(() => err);
					})
				)
				.subscribe((resp) => {
					if (!resp.emailConfirmed) {
						this.store.dispatch([new GenericActions.UserRole(resp)]);
						this.SilentlogOut();
					} else {
						this.store.dispatch([
							new GenericActions.UserRole(resp),
							new GenericActions.GetPromptProperties(),
							new ApplicationsActions.GetApplications(),
							new SavedJobsActions.GetSavedJobs(),
							new CandidatePersonalDetailsAction.GetPersonalDetailsTab(),
							new AuthActions.SetLogged(true)
						]);
						this.signupQuestionsSignal.getSignupQuestions();
						this.featureFlagService.intializeFlagsmith(resp.email) ;

						if (resp.email.includes('@cloudstaff.com')) {
							this.store.dispatch([
								new CandidatePersonalDetailsAction.SyncStatus()
							]);
						}
					}
				});
		}
	}

	checkAndSetActiveAccount() {
		let activeAccount = this.authService.instance.getActiveAccount();
		if (
			!activeAccount &&
			this.authService.instance.getAllAccounts().length > 0
		) {
			let accounts = this.authService.instance.getAllAccounts();
			this.authService.instance.setActiveAccount(accounts[0]);
		}
	}

	login(userFlowRequest?: RedirectRequest | PopupRequest) {
		console.log(JSON.stringify(environment.identity));
		this.mobileDrawer = false;
		this.msalLoginService.msalLogin(userFlowRequest);
	}
	logout() {
		localStorage.clear();
		this.authService.logout();
		this.store.dispatch(new AuthActions.SetLogged(false));
	}

	public async SilentlogOut(): Promise<void> {
		localStorage.clear();

		return this.authService.instance.logout({
			account: this.authService.instance.getActiveAccount(),
			onRedirectNavigate: () => {
				return false;
			}
		});
	}

	editProfile() {
		let editProfileFlowRequest: RedirectRequest | PopupRequest = {
			authority: b2cPolicies.authorities.editProfile.authority,
			scopes: []
		};

		this.login(editProfileFlowRequest);
	}

	public showRegistration() {
		this.mobileDrawer = false;
		this.isRegisteredCheckerVisible = false;
		this.store.dispatch(new GenericActions.ToggleRegistration());
	}

	public hideRegistration() {
		this.store.dispatch(new GenericActions.ToggleRegistration());
	}

	public hideLogin() {
		this.isShowLogin = false;
	}

	public showRegistrationFromLogin() {
		this.isShowLogin = false;
		setTimeout(() => {
			this.store.dispatch(new GenericActions.ToggleRegistration());
		}, 500);
	}

	public showLoginFromRegistration() {
		this.isRegisteredCheckerVisible = false;
		this.store.dispatch(new GenericActions.ToggleRegistration());
	}

	public jobListRedirect() {
		this.mobileDrawer = false;
		if (this.setCountryOrigin) {
			this.router.navigate(['/job-list'], {
				queryParams: { location: this.setCountryOrigin }
			});
		} else {
			this.router.navigate(['/job-list']);
		}
	}

	public closeDrawer() {
		this.mobileDrawer = false;
	}

	mobileDrawerOpen(): void {
		this.mobileDrawer = true;
	}

	mobileDrawerClose(): void {
		this.mobileDrawer = false;
	}

	ngOnDestroy(): void {
		this._destroying$.next(undefined);
		this._destroying$.complete();
	}

	public getProfilePix(image: string): string {
		if (
			image?.includes('no-avatar') ||
			image === '' ||
			image === null ||
			image === undefined
		) {
			return this.siteData.profile.headerDefaultImage;
		} else {
			return image;
		}
	}

	private modalChecking(): void {
		const isLogged = localStorage.getItem('isLogged');

		if (!isLogged) {
			localStorage.setItem('isLogged', 'true');
			localStorage.setItem('profileId', this.genericData.userRole.profileId);
			const selectedJrId = this.getCookie('selectedJrId');
			if (selectedJrId) {
				this.msalLoginService.globalJobRequestApply(parseInt(selectedJrId));
				this.deleteCookie('selectedJrId');
			}

			this.notification.blank(
				'Welcome ' + this.genericData.userRole.friendlyName + '!',
				'Update your profile and start exploring jobs.'
			);
		}
	}

	public buildChangePasswordForm(): void {
		this.changePasswordForm = this.fb.group(
			{
				currentPassword: ['', [Validators.required, Validators.minLength(2)]],
				newPassword: [
					'',
					[Validators.required, Validators.pattern(this.strongPasswordRegx)]
				],
				confirmPassword: [
					'',
					[
						Validators.required
						// this.passwordMatcher.bind(this)
					]
				]
			},
			{ validator: this.checkPassword('newPassword', 'confirmPassword') }
		);
	}

	checkPassword(controlName: string, matchingControlName: string) {
		return (formGroup: FormGroup) => {
			const control = formGroup.controls[controlName];
			const matchingControl = formGroup.controls[matchingControlName];
			if (matchingControl.errors) {
				// return if another validator has already found an error on the matchingControl
				return;
			}
			// set error on matchingControl if validation fails
			if (control.value !== matchingControl.value) {
				matchingControl.setErrors({ mustMatch: true });
				this.isPasswordSame = matchingControl.status == 'VALID' ? true : false;
			} else {
				matchingControl.setErrors(null);
				this.isPasswordSame = matchingControl.status == 'VALID' ? true : false;
			}
		};
	}

	public changePassword(): void {
		this.closeDrawer();
		this.buildChangePasswordForm();
		this.showChangePassword = true;
	}

	public saveChangePassword(): void {
		this.changePasswordForm.markAllAsTouched();
		if (this.changePasswordForm.status === 'INVALID') return;
		const data = {
			currentPassword: this.changePasswordForm.value.currentPassword,
			newPassword: this.changePasswordForm.value.newPassword
		};
		this.genericService
			.post('ApplicantProtected/changePassword', data)
			.subscribe({
				next: (data: any) => {
					this.nzMessage.success('Change password successful');
					this.closeChangePassword();
				},
				error: () => {
					this.nzMessage.error('Error saving');
				}
			});
	}

	public closeChangePassword(): void {
		this.showChangePassword = false;
	}

	public closeRegisteredCheckerVisible(): void {
		this.isRegisteredCheckerVisible = false;
	}

	public onJobAlertClicked(): void {
		this.isJobAlertModal = true;
		this.closeDrawer();
	}

	public jobAlertModalEvent(event: boolean): void {
		this.isJobAlertModal = event;
	}

	private getCookie(name: string): string {
		const cookies = document.cookie.split('; ');
		for (const cookie of cookies) {
			const [key, value] = cookie.split('=');
			if (key === name) {
				return value;
			}
		}
		return '';
	}

	private deleteCookie(name: string): void {
		document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
	}

	private removeRefQueryString(): void {
		const url = new URL(window.location.href);
		let dataCheck = url.searchParams.get('ref');
		if (dataCheck === null) return;
		url.searchParams.delete('ref');
		window.history.replaceState({}, document.title, url.toString());
	}
}
